"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgGoogle(props, svgRef) {
  return (0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 16",
    ref: svgRef
  }, props), {}, {
    children: (0, _jsxRuntime.jsxs)("g", {
      fillRule: "nonzero",
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#4285F4",
        d: "M13.462 8.255c0-.37-.03-.742-.094-1.106H8.234v2.096h2.94a2.52 2.52 0 01-1.088 1.654v1.36h1.754c1.03-.948 1.622-2.348 1.622-4.004z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#34A853",
        d: "M8.234 13.573c1.468 0 2.706-.482 3.608-1.314l-1.754-1.36c-.488.332-1.118.52-1.852.52-1.42 0-2.624-.958-3.056-2.246H3.37v1.402a5.444 5.444 0 004.864 2.998z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#FBBC04",
        d: "M5.178 9.173a3.26 3.26 0 010-2.084V5.687H3.37a5.448 5.448 0 000 4.888l1.808-1.402z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "#EA4335",
        d: "M8.234 4.841a2.958 2.958 0 012.088.816l1.554-1.554a5.231 5.231 0 00-3.642-1.416 5.442 5.442 0 00-4.864 3l1.808 1.402c.43-1.29 1.636-2.248 3.056-2.248z"
      })]
    })
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Google.js.map